import { render } from "./Select2.vue?vue&type=template&id=5d0d2c3e&scoped=true"
import script from "./Select2.vue?vue&type=script&lang=js"
export * from "./Select2.vue?vue&type=script&lang=js"

import "./Select2.vue?vue&type=style&index=0&id=5d0d2c3e&scoped=true&lang=css"
import "./Select2.vue?vue&type=style&index=1&id=5d0d2c3e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0d2c3e"]])

export default __exports__